import {
  initPlansSwitcher,
  initPlansSlider,
} from "./components/pricing-plans/index.js";

export class PricingPage {
  constructor(options) {
    this.options = $.extend(
      {
        node: $(".pricing-plans"),
      },
      options
    );

    $(window).on("resize", () => {
      this._initIncludedFeaturesAccordion();
    });

    initPlansSwitcher();
    initPlansSlider();
    this._initIncludedFeaturesAccordion();
    // this._initEnterprisePopup();
  }

  _initIncludedFeaturesAccordion() {
    var width = $(window).width();

    if (width < 768) {
      // add accordion

      $(".plans-include__item .item__content").css("max-height", "0");

      $(".plans-include__item .item__header").on("click", (event) => {
        let $target = $(event.currentTarget);
        let $content = $target.next();

        $target.toggleClass("active");

        if ($content.height() != 0) {
          $content.css("max-height", 0);
          $content.removeClass("expanded");
        } else {
          $content.css("max-height", $content[0].scrollHeight + "px");
          $content.addClass("expanded");
        }

        $(".plans-include__item .item__content")
          .not($content)
          .css("max-height", 0);
        $(".plans-include__item .item__header")
          .not($target)
          .removeClass("active");
        $(".plans-include__item .item__content")
          .not($content)
          .removeClass("expanded");
      });
    } else {
      // remove accordion

      $(".plans-include__item .item__content").css("max-height", "none");
      $(".plans-include__item .item__header").removeClass("active");

      $(".plans-include__item .item__header").off("click");
    }
  }

	// _initEnterprisePopup() {
	// 	const $window = $(window);
	// 	const $anchor = $('.enterprise-anchor');
	// 	const $popup = $('.enterprise-popup');
	// 	const $closeBtn = $('.enterprise-popup__close');
	//
	// 	// Set popup vertical position relative to anchor
	// 	if ($anchor.length) {
	// 		const popupPadding = $anchor.offset().top;
	// 		$popup.css('top', popupPadding);
	// 	}
	//
	// 	// Handle popup close via mouse click or keyboard (Enter / Space)
	// 	$closeBtn.on('click keydown', function (e) {
	// 		if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
	// 			e.preventDefault();
	// 			$popup.addClass('hidden').attr('hidden', true).removeClass('active');
	// 		}
	// 	});
	//
	// 	// Detect visibility of anchor in viewport and toggle popup
	// 	$window.on('scroll', function () {
	// 		if (!$anchor.length) return;
	//
	// 		const windowHeight = $window.height();
	// 		const windowTop = $window.scrollTop();
	// 		const windowBottom = windowTop + windowHeight;
	//
	// 		const anchorHeight = $anchor.outerHeight();
	// 		const anchorTop = $anchor.offset().top;
	// 		const anchorBottom = anchorTop + anchorHeight;
	//
	// 		// If anchor is visible in viewport → show popup
	// 		if (anchorBottom >= windowTop && anchorTop <= windowBottom) {
	// 			if (!$popup.hasClass('active')) {
	// 				$popup.addClass('active').removeAttr('hidden');
	// 				$popup.attr('aria-hidden', 'false');
	//
	// 				// Move focus to popup close button for accessibility
	// 				$popup.find('.enterprise-popup__close').focus();
	// 			}
	// 		} else {
	// 			// Hide popup when anchor is out of viewport
	// 			$popup.removeClass('active').attr('hidden', true).attr('aria-hidden', 'true');
	// 		}
	// 	});
	//
	// 	// Handle Escape key to close popup
	// 	$(document).on('keydown', function (e) {
	// 		if (e.key === 'Escape' && $popup.hasClass('active')) {
	// 			$popup.addClass('hidden').attr('hidden', true).removeClass('active');
	// 			// Return focus to anchor when popup is closed
	// 			$anchor.focus();
	// 		}
	// 	});
	//
	// 	// Trap focus inside popup when active
	// 	$(document).on('keydown', function (e) {
	// 		if (e.key === 'Tab' && $popup.hasClass('active')) {
	// 			const focusable = $popup.find('a, button, [tabindex="0"], [href]').filter(':visible');
	// 			const first = focusable.first()[0];
	// 			const last = focusable.last()[0];
	//
	// 			if (e.shiftKey && document.activeElement === first) {
	// 				e.preventDefault();
	// 				last.focus();
	// 			} else if (!e.shiftKey && document.activeElement === last) {
	// 				e.preventDefault();
	// 				first.focus();
	// 			}
	// 		}
	// 	});
	// }

}

new PricingPage();


